import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Content from "../components/content"
import SEO from "../components/seo"
import NewsPreview from '../components/news-preview'
import Header from "../components/header"
import ImageBar from "../components/ImageBar"
import Footer from "../components/footer"
import Img from "gatsby-image"

const HomePage = ({ data }) => {
  const meta = data.graphAPI.homepage.meta
  const content = data.graphAPI.homepage.content
  return (
    <main>
      <div className="main">
        <Header />
        <ImageBar isHome="true" />
        <div className="container">
          <div className="main-content">
            <SEO title={meta.title} />
            <div style={{ marginTop: '-5rem' }} className="news-title">
              <h2 className="title is-size-1">Latest News </h2>
            </div>
            <div className="" style={{ marginTop: "3rem", marginBottom: "-0.5rem" }}>
              <Link to="/en-election-information" className="button is-primary mr-2">Election Information</Link>
              <Link to="/es-election-information" className="button is-primary mr-2">Información Electoral</Link><br />
              <a href="https://website-media-galveston-co-mud-12.s3.amazonaws.com/GC_MUD_12_Bond_Auth_Elect_Public_Mtg_Presentation_4_15_2026_9a595a462b.pdf" className="button is-primary mr-2">Presentation for 2026 Bond Authorization Election</a>
              <a href="https://website-media-galveston-co-mud-12.s3.amazonaws.com/Engineers_report_for_2026_election_abea1b9b02.pdf" className="button is-primary mr-2">Engineers Report for 2026 Bond Authorization Election</a>
            </div>
            <NewsPreview posts={data.graphAPI.blogPosts} />
            <div className="has-text-centered" style={{ margin: '-3rem 1rem 3rem' }}>
              <p><strong>You've reached the end. <Link to="/archive">View News Archive</Link></strong></p>
            </div>
            <div className="divider" />
            <div className="title-section">
              <h1 className="title is-size-1">{meta.title}</h1>
            </div>
            <Content content={content} isHome={false} />
          </div>
        </div>
        <Footer />
      </div>
    </main>
  )
}

export default HomePage

export const homePageQuery = graphql`
    query homePage {
        useIt: file(relativePath: {eq: "water-use-it-wisely.png"}) {
            childImageSharp {
                fluid(fit: CONTAIN, maxWidth: 200) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        twdb: file(relativePath: {eq: "TWDB_logo.png"}) {
            childImageSharp {
                fluid(fit: CONTAIN, maxWidth: 200) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        wateriq: file(relativePath: {eq: "wateriq_logo.png"}) {
            childImageSharp {
                fluid(fit: CONTAIN, maxWidth: 200) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        watersmart: file(relativePath: {eq: "logo_watersmart_20161218.png"}) {
            childImageSharp {
                fluid(fit: CONTAIN, maxWidth: 200) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        epa: file(relativePath: {eq: "epa-logo.png"}) {
            childImageSharp {
                fluid(fit: CONTAIN, maxWidth: 200) {
                    ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
        graphAPI {
            homepage {
                meta {
                    id
                    title
                    description
                }
                content {
                    ... on GRAPHAPI_ComponentPageBaseContent {
                        ...baseContent
                    }
                    ... on GRAPHAPI_ComponentPageImage {
                        ...pageImage
                    }
                    ... on GRAPHAPI_ComponentPageLinkCardWithImage {
                        ...linkCardWithImage
                    }
                    ... on GRAPHAPI_ComponentPageSplitContentImage {
                        ...splitContentImage
                    }
                    ... on GRAPHAPI_ComponentPageGallery {
                        ...pageGallery
                    }
                    ... on GRAPHAPI_ComponentPageLinkList {
                        ...pageLinkList
                    }
                }
            }
            blogPosts(limit: 6, sort: "publishedAt:desc") {
                id
                title
                description
                publishedAt
                expiresAt
                heroImage {
                    id
                    url
                    updated_at
                    documentFile {
                        childImageSharp {
                            fluid(maxWidth: 2048){
                                ...GatsbyImageSharpFluid_tracedSVG
                            }
                        }
                    }
                }
            }
        } 
    }
`


